import { useQuery } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";

// The store's categories, shared by the category bar and the printer settings
// (same query key, so one request feeds both).
export const useCategories = () => {
  const { fetchData } = CashierApi();

  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      // Categories are paginated: load every page so none are missing.
      const first = await fetchData("categories", 1);
      if (Array.isArray(first) || !first?.last_page || first.last_page <= 1) {
        return first;
      }

      const rest = await Promise.all(
        Array.from({ length: first.last_page - 1 }, (_, i) =>
          fetchData("categories", i + 2)
        )
      );
      return [first, ...rest].flatMap((page) => page?.data || []);
    },
    retry: 1,
    keepPreviousData: true,
    staleTime: 30 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

// The API returns either a plain array or a paginated { data: [...] }.
export const categoryArray = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
